module.exports = __webpack_public_path__ + "static/grbmember9-9ed8e80bfc4cca07f56bf44b02e49b6c.jpg";